module.exports = __webpack_public_path__ + "img/wireframes_03.968b1db0.png";